import * as React from 'react';

/**
 * Custom Event Wrapper
 * @param name Custom Event Name
 * @param WrappedComponent Wrapped Component
 */
export const withCustomEvent = (WrappedComponent: any) => (props: any) => {
  const handleEmitCustomEvent = (element: any, data: any) => {
    if (!data.name || !data.detail) return;
    const { name, detail } = data;
    const event = new CustomEvent(name, {
      detail: {
        ...detail,
      },
      bubbles: true,
      cancelable: true,
      composed: true, // makes the event jump shadow DOM boundary
    });
    let source = element.target || element.srcElement;
    source.dispatchEvent(event);
  };

  return (
    <>
      <WrappedComponent onEmit={handleEmitCustomEvent} {...props} />
    </>
  );
};
